import {
  getCategoriesList, addCategories, editCategories, deleteCategories,
} from '@/services/categories';

const getters = {
  listCategories: state => state.listCategories,
  totalCategories: state => state.totalCategories,
};

const actions = {
  async requestListCategories({ commit }, { filter, type }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getCategoriesList(filter, type);
      commit('SET_LIST_CATEGORIES', { listCategories: response.data, totalCategories: response.data.length });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddCategories({ commit }, { data, type }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addCategories(data, type);
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-add-categories' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditCategories({ commit }, { data, type }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editCategories(data, type);
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-edit-categories' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteCategories({ commit, dispatch }, { data, filter, type }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteCategories(data, type);
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
      dispatch('requestListCategories', { filter, type });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-delete-categories' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_CATEGORIES(state, { listCategories, totalCategories }) {
    state.listCategories = listCategories;
    state.totalCategories = totalCategories;
  },
};

export default {
  namespaced: true,
  state: {
    listCategories: [],
    totalCategories: 0,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Categories/index.js